import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import queryString from "query-string";

function Types(props) {
  const [answer, setAnswer] = useState(false);
  const [pdf, setPdf] = useState(false);
  const [page, setPage] = useState(false);
  const [email, setEmail] = useState(false);
  const [note, setNote] = useState(false);
  const [youTube, setYouTube] = useState(false);
  const params = queryString.parse(props.location.search);
  const app = params.app || "";

  useEffect(() => {
    if (pdf || email || note || page || youTube) {
      setAnswer(true);
    } else {
      setAnswer(false);
    }
  }, [pdf, page, email, note, youTube]);
  return (
    <div className="center-static">
      <h1 className="headline" style={{ marginBottom: "0px" }}>
        What would you like to listen to?
      </h1>
      <h1 className="subheadline">Select all that apply</h1>
      <div>
        <button
          className="transparent-button clickable"
          style={{
            border: pdf && "3px solid #fb1c7f",
            fontSize: "large",
          }}
          onClick={(e) => {
            setPdf(!pdf);
          }}
        >
          <div>PDFs</div>
          {/* <div
          style={{ fontSize: "large", fontWeight: "normal", marginTop: "5px" }}
        >
          (Private files, public URLs, etc)
        </div> */}
        </button>
        <button
          className="transparent-button clickable"
          style={{
            border: page && "3px solid #fb1c7f",
            fontSize: "large",
          }}
          onClick={(e) => {
            setPage(!page);
          }}
        >
          <div>Web Pages</div>
          {/* <div
          style={{ fontSize: "large", fontWeight: "normal", marginTop: "5px" }}
        >
          (Articles, blogs, etc)
        </div> */}
        </button>
        <button
          className="transparent-button clickable"
          style={{
            border: email && "3px solid #fb1c7f",
            fontSize: "large",
          }}
          onClick={(e) => {
            setEmail(!email);
          }}
        >
          <div>Emails</div>
          {/* <div
          style={{ fontSize: "large", fontWeight: "normal", marginTop: "5px" }}
        >
          (Newsletters, etc)
        </div> */}
        </button>
        <button
          className="transparent-button clickable"
          style={{
            border: note && "3px solid #fb1c7f",
            fontSize: "large",
          }}
          onClick={(e) => {
            setNote(!note);
          }}
        >
          <div>Private Notes</div>
          {/* <div
          style={{ fontSize: "large", fontWeight: "normal", marginTop: "5px" }}
        >
          (Personal notes, GDocs, etc)
        </div> */}
        </button>
        <button
          className="transparent-button clickable"
          style={{
            border: youTube && "3px solid #fb1c7f",
            fontSize: "large",
          }}
          onClick={(e) => {
            setYouTube(!youTube);
          }}
        >
          <div>YouTube </div>
          {/* <div
          style={{ fontSize: "large", fontWeight: "normal", marginTop: "5px" }}
        >
          (Personal notes, GDocs, etc)
        </div> */}
        </button>
      </div>

      {answer && (
        <div className="cta-div" style={{ position: "static" }}>
          <Link
            to={`/onboarding/choosevoice${app && "?app=chrome"}`}
            className="cta-button"
            onClick={(e) => {}}
          >
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div>
                <div>Continue</div>
              </div>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
}

export default Types;
